export default __webpack_public_path__ + "static/media/andes_a_la_costa_17.eef4e001.JPG";